<template>
    <div id="photography-images">
      <!-- Transition group for image transitions -->
      <transition-group tag="ul" name="images">
        <!-- Loop through the shuffled images and display them -->
        <li
          class="image-container"
          v-for="(i, index) in shuffledImages"
          :key="index"
          v-show="index === imgIndex"
        >
          <div class="image" :style="{'background-image': 'url(' + i + ')'}"></div>
        </li>
      </transition-group>
    </div>
  </template>

<script>

export default {
    name:'PhotographyImages',
    data() {
        return {
            imgIndex: 0,
            images: [
            require('../../assets/background/IMG_2174.jpeg'),
                require('../../assets/background/IMG_0527.jpeg'),
                require('../../assets/background/IMG_0747.jpeg'),
                require('../../assets/background/IMG_0915.jpeg'),
                require('../../assets/background/IMG_1723.jpeg'),
                require('../../assets/background/IMG_2682.jpeg'),
                require('../../assets/background/IMG_3532.jpeg'),
                require('../../assets/background/IMG_3545.jpeg'),
                require('../../assets/background/IMG_3622.jpeg'),
                require('../../assets/background/IMG_4004.jpeg'),
                require('../../assets/background/IMG_4078.jpeg'),
                require('../../assets/background/IMG_4236.jpeg'),
                require('../../assets/background/IMG_4266.jpeg'),
                require('../../assets/background/IMG_4320.jpeg'),
                require('../../assets/background/IMG_4642.jpeg'),
                require('../../assets/background/IMG_4743.jpeg'),
                require('../../assets/background/IMG_4851.jpeg'),
                require('../../assets/background/IMG_4890.jpeg'),
                require('../../assets/background/IMG_5467.jpeg'),
                require('../../assets/background/IMG_7215.jpeg'),
                require('../../assets/background/IMG_8738.jpeg'),
                require('../../assets/background/IMG_8827.jpeg'),
                require('../../assets/background/IMG_9459.jpeg'),
            ],
            shuffledImages: [],
            imgIndex: 0,
        }
    },
    created() {
        this.shuffleImages(); // Shuffle images when component is created
    },
    methods: {
        play(){
            // Change the imgIndex per 4 seconds
            setInterval(() => {
                this.imgIndex = (this.imgIndex < this.images.length - 1) ? this.imgIndex + 1 : 0
            }, 5000);
        },
        shuffleImages() {
            this.shuffledImages = [...this.images]; // Clone the images array
            for (let i = this.shuffledImages.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.shuffledImages[i], this.shuffledImages[j]] = [this.shuffledImages[j], this.shuffledImages[i]];
            }
        },
    },
    mounted(){
        this.play()
    },
}
</script>

<style scoped>
#photography-images{
    height: 100vh;
    position: relative;
}

/* image-container styles */
.image-container{
    width: 100%;
    /* height: 600px; */
    height: 800px;
    position: absolute;
}

/* image styles */
.image{
    height: 100vh;
    background-position: center center;
    background: no-repeat center;
    background-size: cover;
}

/* Images Gradiention Animation */
.images-enter-active {
    transition: opacity 3s ease;
}
.images-leave-active {
    transition: 3s;
    z-index: -100;
}
.images-enter{
    opacity: 0;
}
.images-enter-to{
    opacity: 1;
}
</style>